import React from 'react';
import {useSelector} from 'react-redux'
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import { isEmpty } from 'lodash';
import IntlMessages from 'util/IntlMessages';

function MinaBarnUsersList(props) {
    const ChildKontoUsers = useSelector(state => state.accountsData.ChildKontoUsers)
    const [SelectedBarnUsers,setSelectedBarnUsers]=React.useState(0)
    const onChangeBarn=(e)=>{
        let BarnId = e.target.value
        setSelectedBarnUsers(BarnId)
        let Meta = "KontonUser"
        props.handleChange(Meta,BarnId)  
    }
    return (
        <div>
        {
             isEmpty(ChildKontoUsers)?"":
             <form>
             <div style={{ height: 'auto', paddingTop: '10px' }}>
                 <TextField
                 select
                 label={<IntlMessages id="user.Role.User" />}
                 variant="outlined"
                 size="small"
                 value={SelectedBarnUsers}
                 fullWidth
                 onChange={onChangeBarn}
                 SelectProps={{
                     native: true,
                 }}
                 >
                     <option key="0" disabled  value={0}><IntlMessages id="Choose"/></option>
                     <option key="-1" value={-1}><IntlMessages id="All"/></option>
                     {
                         isEmpty(ChildKontoUsers)?[]:
                         ChildKontoUsers.map((option,index) => (
                         <Tooltip key={option.id} title={isEmpty(option.UserEmail)?<IntlMessages id="Customer.InActiv"/>:""} placement="left">
                            <option  value={option.id} style={{ background:isEmpty(option.UserEmail)?"#e6e6e6":""}}>
                                   {option.FirstName} {isEmpty(option.LastName)?"":option.LastName}
                            </option>
                        </Tooltip>
                     ))}
     </TextField>
 </div>
</form>
        }  
        </div>
    );
}

export default MinaBarnUsersList;